import CardBody from 'components/Card/CardBody';
import { CaptionBold, HeadingMBold } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import DetailsRow from './DetailsRow';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import Card from 'components/Card/Card';
import React, { useState } from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/accounts/accountDetailsSubpageStyle';
import { makeStyles } from '@material-ui/core';
import CanPerform from 'components/CanPerform/CanPerform';
import Button from 'components/CustomButtons/Button';
import OrganizationTaxIdDialog from './OrganizationTaxIdDialog';
import PDF from 'assets/img/icons/pdf.svg';

interface IOrganizationTaxIdProps {
	account: types.organizations.IAccount;
}

const OrganizationTaxId = ({ account }: IOrganizationTaxIdProps) => {
	const [taxDialog, setTaxDialog] = useState<boolean>(false);
	// @ts-ignore
	const useStyles = makeStyles(styles);
	const classes = useStyles();
	return (
		<Card>
			<CardBody>
				<HeadingMBold color="primary-light">
					{translate('organization.details.organization.tax.id')}
				</HeadingMBold>
				<ConditionalRender show={!account.accountDetails.taxId}>
					<DetailsRow label={translate('organization.details.empty.tax.id')} />
				</ConditionalRender>
				<ConditionalRender show={!!account.accountDetails.taxId}>
					<DetailsRow label={translate('organization.details.tax.id')} value={account.accountDetails.taxId} />
					<DetailsRow
						label={translate('organization.details.tax.id.certificate')}
						value={<img className={classes.pdfIcon} src={PDF} alt="pdf" />}
					/>
				</ConditionalRender>
				<div className={classes.taxIdDescription}>
					<CaptionBold>{translate('organization.details.tax.id.description')}</CaptionBold>
				</div>
				<CanPerform
					action="organization:edit-organization-tax-id"
					yes={
						<div className={classes.additionalInfoButtonWrapper}>
							<Button
								color="tertiary-light"
								id="edit-organization-tax-id-button"
								onClick={() => setTaxDialog(true)}
							>
								{translate(account.accountDetails.taxId ? 'edit' : 'add')}
							</Button>
						</div>
					}
				/>
			</CardBody>
			<OrganizationTaxIdDialog
				hideDialog={() => setTaxDialog(false)}
				isDialogOpen={taxDialog}
				accountId={account.accountDetails.accountId}
				taxId={account.accountDetails.taxId}
			/>
		</Card>
	);
};

export default OrganizationTaxId;
